(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vybe-case-builder"] && !Shopify.designMode) return;
  try {
    /**
   * Build-a-case: pick a size, step flavors up to the case's bag count, then
   * add every flavor line in one /cart/add.js call, tagged with the case.
   */
  (function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function formatMoney(cents, format) {
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (!format) return '$' + amount;
      return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
    }

    function fill(template, values) {
      return template.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
        return values[key];
      });
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
      document.querySelectorAll('[data-cart-link]').forEach(function (el) {
        el.hidden = false;
      });
    }

    function nextCaseNumber(cart) {
      var highest = 0;
      cart.items.forEach(function (item) {
        var match = item.properties && /^#(\d+)/.exec(item.properties.Case || '');
        if (match) highest = Math.max(highest, parseInt(match[1], 10));
      });
      return highest + 1;
    }

    function setup(builder) {
      var flavorsStep = builder.querySelector('[data-case-flavors]');
      var countEl = builder.querySelector('[data-case-count]');
      var submit = builder.querySelector('[data-case-submit]');
      var status = builder.querySelector('[data-case-status]');
      var rows = Array.prototype.slice.call(builder.querySelectorAll('[data-case-flavor]'));
      var d = builder.dataset;
      var selected = null;

      function variantFor(row) {
        var variants = JSON.parse(row.dataset.variants);
        return selected ? variants[selected.value] : null;
      }

      function countOf(row) {
        return parseInt(row.querySelector('[data-flavor-count]').textContent, 10) || 0;
      }

      function setCount(row, value) {
        row.querySelector('[data-flavor-count]').textContent = value;
      }

      function render() {
        var bags = selected ? parseInt(selected.dataset.bags, 10) : 0;
        var total = 0;
        var price = 0;

        rows.forEach(function (row) {
          var variant = variantFor(row);
          var count = countOf(row);
          if (!variant || !variant.available) {
            count = 0;
            setCount(row, 0);
          }
          total += count;
          if (variant) price += count * variant.price;
          row.classList.toggle('is-unavailable', Boolean(selected) && (!variant || !variant.available));
        });

        rows.forEach(function (row) {
          var variant = variantFor(row);
          var usable = variant && variant.available;
          row.querySelector('[data-flavor-step="-1"]').disabled = !usable || countOf(row) === 0;
          row.querySelector('[data-flavor-step="1"]').disabled = !usable || total >= bags;
        });

        flavorsStep.disabled = !selected;
        countEl.textContent = selected ? fill(d.caseCountText, { count: total, bags: bags }) : '';

        if (!selected) {
          submit.disabled = true;
          submit.textContent = d.pickSizeText;
        } else if (total < bags) {
          submit.disabled = true;
          submit.textContent = bags - total === 1 ? d.pickOneMoreText : fill(d.pickMoreText, { count: bags - total });
        } else {
          submit.disabled = false;
          submit.textContent = fill(d.addText, { price: formatMoney(price, d.moneyFormat) });
        }
      }

      builder.addEventListener('change', function (event) {
        if (event.target.name !== 'case') return;
        selected = event.target;
        var bags = parseInt(selected.dataset.bags, 10);
        var total = rows.reduce(function (sum, row) { return sum + countOf(row); }, 0);
        if (total > bags) rows.forEach(function (row) { setCount(row, 0); });
        status.textContent = '';
        render();
      });

      builder.addEventListener('click', function (event) {
        var step = event.target.closest('[data-flavor-step]');
        if (!step) return;
        var row = step.closest('[data-case-flavor]');
        setCount(row, Math.max(0, countOf(row) + parseInt(step.dataset.flavorStep, 10)));
        status.textContent = '';
        render();
      });

      submit.addEventListener('click', function () {
        if (!selected || !window.fetch) return;
        submit.disabled = true;
        status.textContent = '';

        fetch(root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var number = nextCaseNumber(cart);
            var caseName = fill(d.caseLabelText, {
              number: number,
              bags: selected.dataset.bags,
              size: selected.dataset.label,
            });
            var items = rows
              .filter(function (row) { return countOf(row) > 0; })
              .map(function (row) {
                return {
                  id: variantFor(row).id,
                  quantity: countOf(row),
                  properties: { Case: caseName, _case_bags: selected.dataset.bags },
                };
              });

            return fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items }),
            }).then(function (response) {
              return response.json().then(function (data) {
                if (!response.ok) throw new Error(data.description || data.message);
                return number;
              });
            });
          })
          .then(function (number) {
            return fetch(root + 'cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                updateCartCount(cart.item_count);
                rows.forEach(function (row) { setCount(row, 0); });
                status.innerHTML =
                  fill(d.addedText, { number: number }) + ' <a href="' + root + 'cart">' + d.viewCartText + '</a>';
              });
          })
          .catch(function (error) {
            status.textContent = error.message || d.errorText;
          })
          .finally(render);
      });

      render();
    }

    document.querySelectorAll('[data-vybe-case]').forEach(setup);
  })();
  } catch(e) { console.error(e); }
})();

})();
